import React from 'react';
import { defineMessages } from 'react-intl';
import Message from 'components/Message';

export const messages = defineMessages({
  optionalLabel: {
    id: 'instructor-form.optional-label',
    defaultMessage: 'Optional',
  },
});

const InstructorFormOptionalLabel = () => (
  <Message className="instructor-form__optional-label" message={messages.optionalLabel} />
);

export default InstructorFormOptionalLabel;
